import { z } from 'zod'

import { dbEntitySchema, listQueryZodFields } from './system'
import { AdmissionGroupTagType } from '../constants/admissionGroupTag'

const baseTagProps = {
  id: z.string(),
  value: z.string(),
  backgroundColor: z.string().nullish(),
  textColor: z.string().nullish(),
  icon: z.string().optional().nullable(),
  type: z
    .nativeEnum(AdmissionGroupTagType)
    .default(AdmissionGroupTagType.CUSTOM),
}

export const admissionGroupTagBaseSchema = z.object(baseTagProps)

export const admissionGroupTagSchema = dbEntitySchema.extend({
  ...baseTagProps,
  organization: z.string(),
})

export const admissionGroupTagListQuerySchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string(),
  search: z.string().optional().nullable(),
  type: z
    .nativeEnum(AdmissionGroupTagType)
    .or(z.array(z.nativeEnum(AdmissionGroupTagType)))
    .optional()
    .nullable(),
})

export const admissionGroupTagCreateSchema = admissionGroupTagSchema
  .omit({
    _id: true,
    id: true,
    deleted: true,
    created: true,
    modified: true,
    organization: true,
    type: true,
  })
  .extend({
    organizationId: z.string(),
  })

export const admissionGroupTagUpdateByIdSchema = admissionGroupTagSchema
  .partial()
  .omit({
    _id: true,
    id: true,
    deleted: true,
    created: true,
    modified: true,
    organization: true,
    type: true,
  })

export const admissionGroupTagListResponseSchema = z.object({
  data: z.array(admissionGroupTagSchema),
})
